webpackJsonp(["pages.projects.jobs.show"],{

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./build_variables.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = handleRevealVariables;
/* eslint-disable func-names*/

function handleRevealVariables() {
  $('.js-reveal-variables').off('click').on('click', function () {
    $('.js-build-variables').toggle();
    $(this).hide();
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./job.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_number_utils__ = __webpack_require__("./lib/utils/number_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var Job = function () {
  function Job(options) {
    var _this = this;

    _classCallCheck(this, Job);

    this.timeout = null;
    this.state = null;
    this.fetchingStatusFavicon = false;
    this.options = options || $('.js-build-options').data();

    this.pagePath = this.options.pagePath;
    this.buildStatus = this.options.buildStatus;
    this.state = this.options.logState;
    this.buildStage = this.options.buildStage;
    this.$document = $(document);
    this.$window = $(window);
    this.logBytes = 0;
    this.updateDropdown = this.updateDropdown.bind(this);

    this.$buildTrace = $('#build-trace');
    this.$buildRefreshAnimation = $('.js-build-refresh');
    this.$truncatedInfo = $('.js-truncated-info');
    this.$buildTraceOutput = $('.js-build-output');
    this.$topBar = $('.js-top-bar');

    // Scroll controllers
    this.$scrollTopBtn = $('.js-scroll-up');
    this.$scrollBottomBtn = $('.js-scroll-down');

    clearTimeout(this.timeout);

    this.initSidebar();
    this.populateJobs(this.buildStage);
    this.updateStageDropdownText(this.buildStage);
    this.sidebarOnResize();

    this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.sidebarOnClick.bind(this));

    this.$document.off('click', '.stage-item').on('click', '.stage-item', this.updateDropdown);

    // add event listeners to the scroll buttons
    this.$scrollTopBtn.off('click').on('click', this.scrollToTop.bind(this));

    this.$scrollBottomBtn.off('click').on('click', this.scrollToBottom.bind(this));

    this.scrollThrottled = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(this.toggleScroll.bind(this), 100);

    this.$window.off('scroll').on('scroll', function () {
      if (!_this.isScrolledToBottom()) {
        _this.toggleScrollAnimation(false);
      } else if (_this.isScrolledToBottom() && !_this.isLogComplete) {
        _this.toggleScrollAnimation(true);
      }
      _this.scrollThrottled();
    });

    this.$window.off('resize.build').on('resize.build', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(this.sidebarOnResize.bind(this), 100));

    this.initAffixTopArea();

    this.getBuildTrace();
  }

  _createClass(Job, [{
    key: 'initAffixTopArea',
    value: function initAffixTopArea() {
      /**
        If the browser does not support position sticky, it returns the position as static.
        If the browser does support sticky, then we allow the browser to handle it, if not
        then we default back to Bootstraps affix
      **/
      if (this.$topBar.css('position') !== 'static') return;

      var offsetTop = this.$buildTrace.offset().top;

      this.$topBar.affix({
        offset: {
          top: offsetTop
        }
      });
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canScroll',
    value: function canScroll() {
      return $(document).height() > $(window).height();
    }
  }, {
    key: 'toggleScroll',
    value: function toggleScroll() {
      var $document = $(document);
      var currentPosition = $document.scrollTop();
      var scrollHeight = $document.height();

      var windowHeight = $(window).height();
      if (this.canScroll()) {
        if (currentPosition > 0 && scrollHeight - currentPosition !== windowHeight) {
          // User is in the middle of the log

          this.toggleDisableButton(this.$scrollTopBtn, false);
          this.toggleDisableButton(this.$scrollBottomBtn, false);
        } else if (currentPosition === 0) {
          // User is at Top of  Log

          this.toggleDisableButton(this.$scrollTopBtn, true);
          this.toggleDisableButton(this.$scrollBottomBtn, false);
        } else if (this.isScrolledToBottom()) {
          // User is at the bottom of the build log.

          this.toggleDisableButton(this.$scrollTopBtn, false);
          this.toggleDisableButton(this.$scrollBottomBtn, true);
        }
      } else {
        this.toggleDisableButton(this.$scrollTopBtn, true);
        this.toggleDisableButton(this.$scrollBottomBtn, true);
      }
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'isScrolledToBottom',
    value: function isScrolledToBottom() {
      var $document = $(document);

      var currentPosition = $document.scrollTop();
      var scrollHeight = $document.height();

      var windowHeight = $(window).height();

      return scrollHeight - currentPosition === windowHeight;
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'scrollDown',
    value: function scrollDown() {
      var $document = $(document);
      $document.scrollTop($document.height());
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.scrollDown();
      this.hasBeenScrolled = true;
      this.toggleScroll();
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      $(document).scrollTop(0);
      this.hasBeenScrolled = true;
      this.toggleScroll();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'toggleDisableButton',
    value: function toggleDisableButton($button, disable) {
      if (disable && $button.prop('disabled')) return;
      $button.prop('disabled', disable);
    }
  }, {
    key: 'toggleScrollAnimation',
    value: function toggleScrollAnimation(toggle) {
      this.$scrollBottomBtn.toggleClass('animate', toggle);
    }
  }, {
    key: 'initSidebar',
    value: function initSidebar() {
      this.$sidebar = $('.js-build-sidebar');
    }
  }, {
    key: 'getBuildTrace',
    value: function getBuildTrace() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.pagePath + '/trace.json', {
        params: { state: this.state }
      }).then(function (res) {
        var log = res.data;

        if (!_this2.fetchingStatusFavicon) {
          _this2.fetchingStatusFavicon = true;

          Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__["E" /* setCiStatusFavicon */])(_this2.pagePath + '/status.json').then(function () {
            _this2.fetchingStatusFavicon = false;
          }).catch(function () {
            _this2.fetchingStatusFavicon = false;
          });
        }

        if (log.state) {
          _this2.state = log.state;
        }

        _this2.isScrollInBottom = _this2.isScrolledToBottom();

        if (log.append) {
          _this2.$buildTraceOutput.append(log.html);
          _this2.logBytes += log.size;
        } else {
          _this2.$buildTraceOutput.html(log.html);
          _this2.logBytes = log.size;
        }

        // if the incremental sum of logBytes we received is less than the total
        // we need to show a message warning the user about that.
        if (_this2.logBytes < log.total) {
          // size is in bytes, we need to calculate KiB
          var size = Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_number_utils__["c" /* numberToHumanSize */])(_this2.logBytes);
          $('.js-truncated-info-size').html('' + size);
          _this2.$truncatedInfo.removeClass('hidden');
        } else {
          _this2.$truncatedInfo.addClass('hidden');
        }
        _this2.isLogComplete = log.complete;

        if (log.complete === false) {
          _this2.timeout = setTimeout(function () {
            _this2.getBuildTrace();
          }, 4000);
        } else {
          _this2.$buildRefreshAnimation.remove();
          _this2.toggleScrollAnimation(false);
        }

        if (log.status !== _this2.buildStatus) {
          Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["g" /* visitUrl */])(_this2.pagePath);
        }
      }).catch(function () {
        _this2.$buildRefreshAnimation.remove();
      }).then(function () {
        if (_this2.isScrollInBottom) {
          _this2.scrollDown();
        }
      }).then(function () {
        return _this2.toggleScroll();
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'shouldHideSidebarForViewport',
    value: function shouldHideSidebarForViewport() {
      var bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_3__breakpoints__["a" /* default */].getBreakpointSize();
      return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(shouldHide) {
      var shouldShow = typeof shouldHide === 'boolean' ? !shouldHide : undefined;
      var $toggleButton = $('.js-sidebar-build-toggle-header');

      this.$sidebar.toggleClass('right-sidebar-expanded', shouldShow).toggleClass('right-sidebar-collapsed', shouldHide);

      this.$topBar.toggleClass('sidebar-expanded', shouldShow).toggleClass('sidebar-collapsed', shouldHide);

      if (this.$sidebar.hasClass('right-sidebar-expanded')) {
        $toggleButton.addClass('hidden');
      } else {
        $toggleButton.removeClass('hidden');
      }
    }
  }, {
    key: 'sidebarOnResize',
    value: function sidebarOnResize() {
      this.toggleSidebar(this.shouldHideSidebarForViewport());
    }
  }, {
    key: 'sidebarOnClick',
    value: function sidebarOnClick() {
      if (this.shouldHideSidebarForViewport()) this.toggleSidebar();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'populateJobs',
    value: function populateJobs(stage) {
      $('.build-job').hide();
      $('.build-job[data-stage="' + stage + '"]').show();
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'updateStageDropdownText',
    value: function updateStageDropdownText(stage) {
      $('.stage-selection').text(stage);
    }
  }, {
    key: 'updateDropdown',
    value: function updateDropdown(e) {
      e.preventDefault();
      var stage = e.currentTarget.text;
      this.updateStageDropdownText(stage);
      this.populateJobs(stage);
    }
  }]);

  return Job;
}();

/* harmony default export */ __webpack_exports__["a"] = (Job);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDDEN_CLASS; });
var BYTES_IN_KIB = 1024;
var HIDDEN_CLASS = 'hidden';

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/number_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatRelevantDigits;
/* unused harmony export bytesToKiB */
/* harmony export (immutable) */ __webpack_exports__["a"] = bytesToMiB;
/* unused harmony export bytesToGiB */
/* harmony export (immutable) */ __webpack_exports__["c"] = numberToHumanSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./lib/utils/constants.js");


/**
 * Function that allows a number with an X amount of decimals
 * to be formatted in the following fashion:
 * * For 1 digit to the left of the decimal point and X digits to the right of it
 * * * Show 3 digits to the right
 * * For 2 digits to the left of the decimal point and X digits to the right of it
 * * * Show 2 digits to the right
*/
function formatRelevantDigits(number) {
  var digitsLeft = '';
  var relevantDigits = 0;
  var formattedNumber = '';
  if (!isNaN(Number(number))) {
    digitsLeft = number.toString().split('.')[0];
    switch (digitsLeft.length) {
      case 1:
        relevantDigits = 3;
        break;
      case 2:
        relevantDigits = 2;
        break;
      case 3:
        relevantDigits = 1;
        break;
      default:
        relevantDigits = 4;
        break;
    }
    formattedNumber = Number(number).toFixed(relevantDigits);
  }
  return formattedNumber;
}

/**
 * Utility function that calculates KiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        KiB
 */
function bytesToKiB(number) {
  return number / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */];
}

/**
 * Utility function that calculates MiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        MiB
 */
function bytesToMiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Utility function that calculates GiB of the given bytes.
 * @param {Number} number
 * @returns {Number}
 */
function bytesToGiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Port of rails number_to_human_size
 * Formats the bytes in number into a more understandable
 * representation (e.g., giving it 1500 yields 1.5 KB).
 *
 * @param {Number} size
 * @returns {String}
 */
function numberToHumanSize(size) {
  if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return size + ' bytes';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToKiB(size).toFixed(2) + ' KiB';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToMiB(size).toFixed(2) + ' MiB';
  }
  return bytesToGiB(size).toFixed(2) + ' GiB';
}

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./pages/projects/jobs/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: ./jobs/stores/job_store.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JobStore = function () {
  function JobStore() {
    _classCallCheck(this, JobStore);

    this.state = {
      job: {}
    };
  }

  _createClass(JobStore, [{
    key: "storeJob",
    value: function storeJob() {
      var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.job = job;
    }
  }]);

  return JobStore;
}();

/* harmony default export */ var job_store = (JobStore);
// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// CONCATENATED MODULE: ./jobs/services/job_service.js
var job_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function job_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var job_service_JobService = function () {
  function JobService(endpoint) {
    job_service__classCallCheck(this, JobService);

    this.job = endpoint;
  }

  job_service__createClass(JobService, [{
    key: 'getJob',
    value: function getJob() {
      return axios_utils["a" /* default */].get(this.job);
    }
  }]);

  return JobService;
}();

/* harmony default export */ var job_service = (job_service_JobService);
// EXTERNAL MODULE: ./job.js
var job = __webpack_require__("./job.js");

// EXTERNAL MODULE: ./build_variables.js
var build_variables = __webpack_require__("./build_variables.js");

// CONCATENATED MODULE: ./jobs/job_details_mediator.js
var job_details_mediator__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function job_details_mediator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Build */









var job_details_mediator_JobMediator = function () {
  function JobMediator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    job_details_mediator__classCallCheck(this, JobMediator);

    this.options = options;

    this.store = new job_store();
    this.service = new job_service(options.endpoint);

    this.state = {
      isLoading: false
    };
  }

  job_details_mediator__createClass(JobMediator, [{
    key: 'initBuildClass',
    value: function initBuildClass() {
      this.build = new job["a" /* default */]();
      Object(build_variables["a" /* default */])();
    }
  }, {
    key: 'fetchJob',
    value: function fetchJob() {
      var _this = this;

      this.poll = new poll["a" /* default */]({
        resource: this.service,
        method: 'getJob',
        successCallback: function successCallback(response) {
          return _this.successCallback(response);
        },
        errorCallback: function errorCallback() {
          return _this.errorCallback();
        }
      });

      if (!visibilityjs_default.a.hidden()) {
        this.state.isLoading = true;
        this.poll.makeRequest();
      } else {
        this.getJob();
      }

      visibilityjs_default.a.change(function () {
        if (!visibilityjs_default.a.hidden()) {
          _this.poll.restart();
        } else {
          _this.poll.stop();
        }
      });
    }
  }, {
    key: 'getJob',
    value: function getJob() {
      var _this2 = this;

      return this.service.getJob().then(function (response) {
        return _this2.successCallback(response);
      }).catch(function () {
        return _this2.errorCallback();
      });
    }
  }, {
    key: 'successCallback',
    value: function successCallback(response) {
      this.state.isLoading = false;
      return this.store.storeJob(response.data);
    }
  }, {
    key: 'errorCallback',
    value: function errorCallback() {
      this.state.isLoading = false;

      return new flash["a" /* default */]('An error occurred while fetching the job.');
    }
  }]);

  return JobMediator;
}();

/* harmony default export */ var job_details_mediator = (job_details_mediator_JobMediator);
// EXTERNAL MODULE: ./vue_shared/components/header_ci_component.vue + 2 modules
var header_ci_component = __webpack_require__("./vue_shared/components/header_ci_component.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./jobs/components/header.vue




/* harmony default export */ var header = ({
  name: 'JobHeaderSection',
  components: {
    ciHeader: header_ci_component["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      actions: this.getActions()
    };
  },

  computed: {
    status: function status() {
      return this.job && this.job.status;
    },
    shouldRenderContent: function shouldRenderContent() {
      return !this.isLoading && Object.keys(this.job).length;
    },

    /**
     * When job has not started the key will be `false`
     * When job started the key will be a string with a date.
     */
    jobStarted: function jobStarted() {
      return !this.job.started === false;
    }
  },
  watch: {
    job: function job() {
      this.actions = this.getActions();
    }
  },
  methods: {
    getActions: function getActions() {
      var actions = [];

      if (this.job.new_issue_path) {
        actions.push({
          label: 'New issue',
          path: this.job.new_issue_path,
          cssClass: 'js-new-issue btn btn-new btn-inverted visible-md-block visible-lg-block',
          type: 'link'
        });
      }
      return actions;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24cfee1d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./jobs/components/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-build-header build-header top-area"},[(_vm.shouldRenderContent)?_c('ci-header',{attrs:{"status":_vm.status,"item-name":"Job","item-id":_vm.job.id,"time":_vm.job.created_at,"user":_vm.job.user,"actions":_vm.actions,"has-sidebar-button":true,"should-render-triggered-label":_vm.jobStarted}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-default append-bottom-default",attrs:{"size":"2"}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./jobs/components/header.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  header,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_header = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./jobs/components/sidebar_detail_row.vue

/* harmony default export */ var sidebar_detail_row = ({
  name: 'SidebarDetailRow',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    hasTitle: function hasTitle() {
      return this.title.length > 0;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2b85ae","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./jobs/components/sidebar_detail_row.vue
var sidebar_detail_row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"build-detail-row"},[(_vm.hasTitle)?_c('span',{staticClass:"build-light-text"},[_vm._v("\n    "+_vm._s(_vm.title)+":\n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var sidebar_detail_row_staticRenderFns = []

// CONCATENATED MODULE: ./jobs/components/sidebar_detail_row.vue
/* script */


/* template */

/* template functional */
var sidebar_detail_row___vue_template_functional__ = false
/* styles */
var sidebar_detail_row___vue_styles__ = null
/* scopeId */
var sidebar_detail_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar_detail_row___vue_module_identifier__ = null

var sidebar_detail_row_Component = Object(component_normalizer["a" /* default */])(
  sidebar_detail_row,
  sidebar_detail_row_render,
  sidebar_detail_row_staticRenderFns,
  sidebar_detail_row___vue_template_functional__,
  sidebar_detail_row___vue_styles__,
  sidebar_detail_row___vue_scopeId__,
  sidebar_detail_row___vue_module_identifier__
)

/* harmony default export */ var components_sidebar_detail_row = (sidebar_detail_row_Component.exports);

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./jobs/components/sidebar_details_block.vue






/* harmony default export */ var sidebar_details_block = ({
  name: 'SidebarDetailsBlock',
  components: {
    detailRow: components_sidebar_detail_row,
    loadingIcon: loading_icon["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    job: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    shouldRenderContent: function shouldRenderContent() {
      return !this.isLoading && Object.keys(this.job).length > 0;
    },
    coverage: function coverage() {
      return this.job.coverage + '%';
    },
    duration: function duration() {
      return Object(datetime_utility["g" /* timeIntervalInWords */])(this.job.duration);
    },
    queued: function queued() {
      return Object(datetime_utility["g" /* timeIntervalInWords */])(this.job.queued);
    },
    runnerId: function runnerId() {
      return '#' + this.job.runner.id;
    },
    renderBlock: function renderBlock() {
      return this.job.merge_request || this.job.duration || this.job.finished_data || this.job.erased_at || this.job.queued || this.job.runner || this.job.coverage || this.job.tags.length || this.job.cancel_path;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eaa4b36","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./jobs/components/sidebar_details_block.vue
var sidebar_details_block_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shouldRenderContent)?[(_vm.job.retry_path || _vm.job.new_issue_path)?_c('div',{staticClass:"block retry-link"},[(_vm.job.new_issue_path)?_c('a',{staticClass:"js-new-issue btn btn-new btn-inverted",attrs:{"href":_vm.job.new_issue_path}},[_vm._v("\n        新建问题\n      ")]):_vm._e(),_vm._v(" "),(_vm.job.retry_path)?_c('a',{staticClass:"js-retry-job btn btn-inverted-secondary",attrs:{"href":_vm.job.retry_path,"data-method":"post","rel":"nofollow"}},[_vm._v("\n        重试\n      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{block : _vm.renderBlock }},[(_vm.job.merge_request)?_c('p',{staticClass:"build-detail-row js-job-mr"},[_c('span',{staticClass:"build-light-text"},[_vm._v("\n          合并请求:\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.job.merge_request.path}},[_vm._v("\n          !"+_vm._s(_vm.job.merge_request.iid)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.job.duration)?_c('detail-row',{staticClass:"js-job-duration",attrs:{"title":"持续时间","value":_vm.duration}}):_vm._e(),_vm._v(" "),(_vm.job.finished_at)?_c('detail-row',{staticClass:"js-job-finished",attrs:{"title":"完成时间","value":_vm.timeFormated(_vm.job.finished_at)}}):_vm._e(),_vm._v(" "),(_vm.job.erased_at)?_c('detail-row',{staticClass:"js-job-erased",attrs:{"title":"擦除时间","value":_vm.timeFormated(_vm.job.erased_at)}}):_vm._e(),_vm._v(" "),(_vm.job.queued)?_c('detail-row',{staticClass:"js-job-queued",attrs:{"title":"排队中","value":_vm.queued}}):_vm._e(),_vm._v(" "),(_vm.job.runner)?_c('detail-row',{staticClass:"js-job-runner",attrs:{"title":"Runner","value":_vm.runnerId}}):_vm._e(),_vm._v(" "),(_vm.job.coverage)?_c('detail-row',{staticClass:"js-job-coverage",attrs:{"title":"覆盖率","value":_vm.coverage}}):_vm._e(),_vm._v(" "),(_vm.job.tags.length)?_c('p',{staticClass:"build-detail-row js-job-tags"},[_c('span',{staticClass:"build-light-text"},[_vm._v("\n          标签:\n        ")]),_vm._v(" "),_vm._l((_vm.job.tags),function(tag,i){return _c('span',{key:i,staticClass:"label label-primary"},[_vm._v("\n          "+_vm._s(tag)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.job.cancel_path)?_c('div',{staticClass:"btn-group prepend-top-5",attrs:{"role":"group"}},[_c('a',{staticClass:"js-cancel-job btn btn-sm btn-default",attrs:{"href":_vm.job.cancel_path,"data-method":"post","rel":"nofollow"}},[_vm._v("\n          取消\n        ")])]):_vm._e()],1)]:_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-10",attrs:{"size":"2"}}):_vm._e()],2)}
var sidebar_details_block_staticRenderFns = []

// CONCATENATED MODULE: ./jobs/components/sidebar_details_block.vue
/* script */


/* template */

/* template functional */
var sidebar_details_block___vue_template_functional__ = false
/* styles */
var sidebar_details_block___vue_styles__ = null
/* scopeId */
var sidebar_details_block___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar_details_block___vue_module_identifier__ = null

var sidebar_details_block_Component = Object(component_normalizer["a" /* default */])(
  sidebar_details_block,
  sidebar_details_block_render,
  sidebar_details_block_staticRenderFns,
  sidebar_details_block___vue_template_functional__,
  sidebar_details_block___vue_styles__,
  sidebar_details_block___vue_scopeId__,
  sidebar_details_block___vue_module_identifier__
)

/* harmony default export */ var components_sidebar_details_block = (sidebar_details_block_Component.exports);

// CONCATENATED MODULE: ./jobs/job_details_bundle.js





/* harmony default export */ var job_details_bundle = (function () {
  var dataset = document.getElementById('js-job-details-vue').dataset;
  var mediator = new job_details_mediator({ endpoint: dataset.endpoint });

  mediator.fetchJob();

  // Header
  // eslint-disable-next-line no-new
  new vue_esm["a" /* default */]({
    el: '#js-build-header-vue',
    components: {
      jobHeader: components_header
    },
    data: function data() {
      return {
        mediator: mediator
      };
    },
    mounted: function mounted() {
      this.mediator.initBuildClass();
    },
    render: function render(createElement) {
      return createElement('job-header', {
        props: {
          isLoading: this.mediator.state.isLoading,
          job: this.mediator.store.state.job
        }
      });
    }
  });

  // Sidebar information block
  // eslint-disable-next-line
  new vue_esm["a" /* default */]({
    el: '#js-details-block-vue',
    components: {
      detailsBlock: components_sidebar_details_block
    },
    data: function data() {
      return {
        mediator: mediator
      };
    },
    render: function render(createElement) {
      return createElement('details-block', {
        props: {
          isLoading: this.mediator.state.isLoading,
          job: this.mediator.store.state.job
        }
      });
    }
  });
});
// CONCATENATED MODULE: ./pages/projects/jobs/show/index.js


document.addEventListener('DOMContentLoaded', job_details_bundle);

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue



/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ var ci_badge_link = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;
      return className ? 'ci-status ci-' + className : 'ci-status';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_badge_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_badge_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_badge_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36896c14","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/header_ci_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/time_ago_tooltip.vue + 2 modules
var time_ago_tooltip = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/header_ci_component.vue







/**
 * Renders header component for job and pipeline page based on UI mockups
 *
 * Used in:
 * - job show page
 * - pipeline show page
 */
/* harmony default export */ var header_ci_component = ({
  components: {
    ciIconBadge: ci_badge_link["a" /* default */],
    loadingIcon: loading_icon["a" /* default */],
    timeagoTooltip: time_ago_tooltip["a" /* default */],
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    actions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    hasSidebarButton: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldRenderTriggeredLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    userAvatarAltText: function userAvatarAltText() {
      return this.user.name + '\'s avatar';
    }
  },

  methods: {
    onClickAction: function onClickAction(action) {
      this.$emit('actionClicked', action);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c769665","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-content-header ci-header-container"},[_c('section',{staticClass:"header-main-content"},[_c('ci-icon-badge',{attrs:{"status":_vm.status}}),_vm._v(" "),_c('strong',[_vm._v("\n        "+_vm._s(_vm.itemName)+" #"+_vm._s(_vm.itemId)+"\n      ")]),_vm._v(" "),(_vm.shouldRenderTriggeredLabel)?[_vm._v("\n        触发时间\n      ")]:[_vm._v("\n        创建时间\n      ")],_vm._v(" "),_c('timeago-tooltip',{attrs:{"time":_vm.time}}),_vm._v("\n\n      作者\n\n      "),(_vm.user)?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-user-link commit-committer-link",attrs:{"href":_vm.user.path,"title":_vm.user.email}},[_c('user-avatar-image',{attrs:{"img-src":_vm.user.avatar_url,"img-alt":_vm.userAvatarAltText,"tooltip-text":_vm.user.name,"img-size":24}}),_vm._v("\n\n          "+_vm._s(_vm.user.name)+"\n        ")],1)]:_vm._e()],2),_vm._v(" "),(_vm.actions.length)?_c('section',{staticClass:"header-action-buttons"},[_vm._l((_vm.actions),function(action,i){return [(action.type === 'link')?_c('a',{key:i,class:action.cssClass,attrs:{"href":action.path}},[_vm._v("\n          "+_vm._s(action.label)+"\n        ")]):(action.type === 'ujs-link')?_c('a',{key:i,class:action.cssClass,attrs:{"href":action.path,"data-method":"post","rel":"nofollow"}},[_vm._v("\n          "+_vm._s(action.label)+"\n        ")]):(action.type === 'button')?_c('button',{key:i,class:action.cssClass,attrs:{"disabled":action.isLoading,"type":"button"},on:{"click":function($event){_vm.onClickAction(action)}}},[_vm._v("\n          "+_vm._s(action.label)+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(action.isLoading),expression:"action.isLoading"}],staticClass:"fa fa-spin fa-spinner",attrs:{"aria-hidden":"true"}})]):_vm._e()]}),_vm._v(" "),(_vm.hasSidebarButton)?_c('button',{staticClass:"btn btn-default visible-xs-block\nvisible-sm-block sidebar-toggle-btn js-sidebar-build-toggle js-sidebar-build-toggle-header",attrs:{"type":"button","aria-label":"Toggle Sidebar","id":"toggleSidebar"}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true","aria-labelledby":"toggleSidebar"}})]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/header_ci_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  header_ci_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_header_ci_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue





/**
 * Port of ruby helper time_ago_with_tooltip
 */

/* harmony default export */ var time_ago_tooltip = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    time: {
      type: String,
      required: true
    },

    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },

    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202207e1","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"title":_vm.tooltipTitle(_vm.time),"data-placement":_vm.tooltipPlacement,"data-container":"body"}},[_vm._v("\n  "+_vm._s(_vm.timeFormated(_vm.time))+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/time_ago_tooltip.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_ago_tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_time_ago_tooltip = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["d" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["a" /* formatDate */])(time);
    }
  }
});

/***/ })

},["./pages/projects/jobs/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.jobs.show.8680ce8729c597c870ce.bundle.js